import { FC, useRef } from 'react'
import styles from './InvisibleComfort.module.scss'
import { CardProps, InvisibleComfortProps } from './types'
import { VideoGif } from 'components/basic/VideoGif'
import { getDefaultCards } from './utils'
import { useGSAP } from '@gsap/react'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/dist/ScrollTrigger'

export const InvisibleComfort: FC<InvisibleComfortProps> = (props) => {
	const { cards = getDefaultCards() } = props

	const containerRef = useRef(null)
	const scrollTriggerRef = useRef(null)

	useGSAP(() => {
		gsap.registerPlugin(ScrollTrigger)
		const videoTimeline = gsap.timeline()
		videoTimeline.add(gsap.from('#invisible_comfort_video', { scale: 0, borderRadius: '100px', ease: 'none' }), 0)
		videoTimeline.add(gsap.to('#invisible_comfort_tag', { opacity: 1, duration: 0.1, ease: 'none' }), 0.1)

		ScrollTrigger.create({
			trigger: '#invisible_comfort',
			start: 'top top',
			end: () => `+=50%`,
			scrub: 1,

			// markers: true,
			animation: videoTimeline,
			// invalidateOnRefresh: true,
		})

		const popUpItems = ['#cards-line1', '#cards-line2', ...cards.map((_, i) => `#inv-card-${i}`)]

		for (const item of popUpItems) {
			gsap.from(item, {
				opacity: 0,
				y: 100,
				duration: 1,
				ease: 'power1.out',

				scrollTrigger: {
					trigger: item,
					toggleActions: 'restart none none reverse',
					start: () => 'top 50%+=400px',
					end: '+=200',
				},
			})
		}
	})

	return (
		<section
			className={styles.container}
			id={'invisible_comfort'}
			ref={containerRef}
		>
			<div className={styles.heading_rails}>
				<header
					className={styles.heading}
					id={'invisible_comfort_title'}
				>
					<p
						className={styles.tag}
						id={'invisible_comfort_tag'}
					>
						New
					</p>
					<h2 id={'invisible_comfort_header'}>
						All the technology,
						<br />
						without sacrificing comfort
					</h2>
				</header>
			</div>

			<div className={styles.video_rails}>
				<VideoGif
					id={'invisible_comfort_video'}
					src={'https://eight-eightsleep-react.s3.us-east-2.amazonaws.com/assets/invisible_comfort_loop_1424_comp.mp4'}
					className={styles.video_bg}
				/>
			</div>

			<div className={styles.card_section}>
				{/* <div className={styles.card_companion_text}>
					<p id={'cards-line1'}>The technology in Pod is hidden within the Cover layer, making it comfortable and powerful.</p>
					<p id={'cards-line2'}>The best comfort that does not change the feel of your mattress.</p>
				</div> */}
				<div className={styles.card_companion_text}>
					<p id={'cards-line1'}>The technology in Pod 4 has been designed to be imperceptible and undetectable to human touch. </p>
					<p id={'cards-line2'}>The best comfort that does not change the feel of your mattress.</p>
				</div>
				<ul className={styles.card_list}>
					{cards.map((card, i) => (
						<li
							key={card.title}
							id={`inv-card-${i}`}
						>
							<Card {...card} />
						</li>
					))}
				</ul>
			</div>

			{/* <div className={styles.alarm_section}>
				<h3 id={'inv-alarm-title'}>The best way to wake up</h3>
				<p id={'inv-alarm-subtitle'}>
					Each morning, wake up with a gentle vibration and thermal change that rises in intensity gradually over 5 minutes. No more noisy alarms or waking your partner up in the morning.
				</p>
			</div> */}
		</section>
	)
}

const Card = (props: CardProps) => {
	return (
		<div className={styles.card}>
			<strong>{props.title}</strong>
			<p>{props.description}</p>
		</div>
	)
}
